import { all, call, put, putResolve, select, take, takeLatest } from "redux-saga/effects";

import { getIsSoloDesign } from "../../lib/selectors";
import { fetchSoloProposalUrl, syncSoloProposal } from "./solo.actions";

// Would be nice if we could utilize the webhooks here and have the sync occur automatically

import soloSlice from "./solo.slice";

function* sync() {
  const syncCall = yield call(syncSoloProposal);
  yield putResolve(syncCall);
}

export function* soloSaga() {
  yield all([take("proposal/fetch/fulfilled"), take("template/fetch/fulfilled")]);
  const isSoloDesign = yield select(getIsSoloDesign);
  if (isSoloDesign) {
    const iframeUrl = yield call(fetchSoloProposalUrl);
    yield put(iframeUrl);
    yield takeLatest(soloSlice.actions.syncSolo, sync);
  }
}
